document.addEventListener('DOMContentLoaded', function() {
  // Check if variant redirects are enabled
  if (theme.settings.enable_variant_redirects) {
    // Create variant to URL mapping from theme settings
    const variantToProductUrl = {
      'Matilda': theme.settings.redirect_matilda,
      'June': theme.settings.redirect_june,
      'Buzz': theme.settings.redirect_buzz,
      'flamingo island': theme.settings.redirect_flamingo_island,
      'Julia': theme.settings.redirect_julia
    };

    // Add click event listeners to swatches
    const swatchElements = document.querySelectorAll('.swatch-element.color');
    swatchElements.forEach(swatch => {
      const label = swatch.querySelector('label');
      const input = swatch.querySelector('input');
      
      if (label && input) {
        const colorValue = input.value;
        
        // If we have a URL for this color, modify the click behavior
        if (variantToProductUrl[colorValue] && variantToProductUrl[colorValue] !== '') {
          label.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = variantToProductUrl[colorValue];
          });
          
          // Add visual indicator to show this is a linkable swatch
          label.style.cursor = 'pointer';
          label.style.position = 'relative';
          
          // Add a small indicator that this swatch links to another product
          if (!label.querySelector('.redirect-indicator')) {
            const indicator = document.createElement('span');
            indicator.className = 'redirect-indicator';
            indicator.innerHTML = '↗️';
            indicator.style.cssText = 'position: absolute; top: -8px; right: -8px; font-size: 10px; background-color: white; border-radius: 50%; padding: 2px;';
            label.appendChild(indicator);
          }
        }
      }
    });
    
    // Hide variant images if enabled
    if (theme.settings.hide_variant_images) {
      const variantImages = document.querySelectorAll('.variant-image');
      variantImages.forEach(img => {
        img.style.display = 'none';
      });
    }
  }
});